/* eslint-disable max-lines */
import {
    Icon20Cancel,
    Icon20Chain,
    Icon20CloudArrowUpOutline,
    Icon20CopyOutline,
    Icon20DeleteOutline,
    Icon20DownloadOutline,
    Icon20FolderSimpleArrowRightOutlune,
    Icon20FullscreenExitOutline,
    Icon20FullscreenOutline,
    Icon20Like,
    Icon20LikeOutline,
    Icon20MailOutline,
    Icon20More,
    Icon20PrinterOutline,
    Icon20Search,
    Icon20WriteOutline,
} from '@vkontakte/icons';
import { downloadAsJpeg } from 'Cloud/Application/DownloadAsJpeg';
import classNames from 'clsx';
import { ReactComponent as ShapeIcon } from 'img/icons/shape.svg';
import { xray } from 'lib/xray';
import React, { Component, createRef, ReactElement } from 'react';
import { canCloneWeblink, getIsCloudAvailabe } from 'reactApp/appHelpers/appHelpers';
import { ENABLE_FULL_RESPONSIVE, IS_BIZ_USER, IS_ONPREMISE, IS_PUBLIC, IS_PUBLIC_FOLDER } from 'reactApp/appHelpers/configHelpers';
import { watchMedia } from 'reactApp/hooks/responsivness/useMinWidthBreakpoint';
import { print } from 'reactApp/hooks/useNormalizedOvidius';
import { AttachesItem, EAttachTypes } from 'reactApp/modules/attaches/attaches.types';
import { requiredAuthorizationHelpers } from 'reactApp/modules/requiredAuthorization/helpers';
import { reDownloadController } from 'reactApp/modules/requiredAuthorization/reDownloadController';
import { snackbarController } from 'reactApp/modules/snackbar/snackbar.controller';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { CloudFile, EStorageType } from 'reactApp/modules/storage/storage.types';
import { IStoryFileItem } from 'reactApp/modules/stories/stories.types';
import { DropdownItemAction } from 'reactApp/ui/DropdownItemAction/DropdownItemAction';
import { DropdownList, DropdownTheme, ListItem } from 'reactApp/ui/DropdownList/DropdownList';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipAppearance, ETooltipPlacement } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { Logo } from 'reactApp/ui/Header/Logo/Logo';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { NameComponent } from 'reactApp/ui/Name/Name';
import { ProtectedHint } from 'reactApp/ui/ProtectedHint/ProtectedHint';
import { AttachInfo } from 'reactApp/ui/ReactViewer/AttachInfo/AttachInfo';
import { DocumentSearch } from 'reactApp/ui/ReactViewer/ViewerHeader/DocumentSearch/DocumentSearch';
import { FaceInfoTooltip } from 'reactApp/ui/ReactViewer/ViewerHeader/FaceInfoTooltip/FaceInfoTooltip';
import { MarketingPromoButton } from 'reactApp/ui/ReactViewer/ViewerHeader/MarketingPromoButton/MarketingPromoButton';
import { RegisterCloudTooltip } from 'reactApp/ui/RegisterCloudTooltip/RegisterCloudTooltip';
import { ExternalLinkIcon } from 'reactApp/ui/VKUIIcons';
import { noop } from 'reactApp/utils/helpers';
import { getSize } from 'reactApp/utils/sizeHelper';

import styles from './ViewerHeader.css';
import { ViewerHeaderButton } from './ViewerHeaderButton';
import buttonStyles from './ViewerHeaderButton.css';

interface Props {
    enableFavorites: boolean;
    isPublic: boolean;
    isStock: boolean;
    isAttaches?: boolean;
    isAuthorized: boolean;
    isArchiveItem?: boolean;
    id?: string;
    item: CloudFile | AttachesItem | IStoryFileItem | null;
    itemStorage?: EStorageType | null;
    toggleFavorite();
    onClose();
    onDownload(unknown);
    onToggleFavorites(item: CloudFile | AttachesItem | IStoryFileItem | null);
    onPublish(unknown);
    onDelete(item: CloudFile | AttachesItem | IStoryFileItem | null);
    onPdfEdit(item: CloudFile | AttachesItem | IStoryFileItem | null);
    onCopy();
    onMove();
    onMail();
    onOpenInMyCloud();
    onClone();
    onOpenParent();
    onActive({ isActive }: { isActive: boolean });
    onFileClick(): void;
    isFullScreen: boolean;
    showLogo?: boolean;
    embedded?: boolean;
    onFullscreen: () => void;
    isB2BBizUser?: boolean;
    isAttachesEnabled?: boolean;
    renderTopChildren?(isActive: boolean);
    topTitle?: string;
    topSubTitle?: string;
    isUnpublished?: boolean;
    facesCount?: number;
    onShowFaceFilter?();
    showFacesFilter?: boolean;
    disableClose?: boolean;
    showPdfEditButton?: boolean;
    contentForPrint?: ArrayBuffer[] | null;
    allowPrinting?: boolean;
    setSearchText: (text: string) => void;
    enableSearch: boolean;
    isSuccessAuthWhenDownload?: boolean;
    isSuccessAuthWhenDownloadVariant1?: boolean;
    isViewerFileVerifiedByKaspersky: boolean;
}

interface State {
    isMoreOpen: boolean;
    isDownloadOpen: boolean;
    isButtonTextHidden: boolean;
    wrapToolbarButtonsOnSmallScreen: boolean;
    onPrintClick: boolean;
    expandSearch: boolean;
}

const getLinkText = 'Получить ссылку';
const unpublishLinkText = 'Отключить ссылку';
const shareLink = 'Поделиться ссылкой';
const deleteFromFavorites = 'Убрать из избранного';
const addToFavorites = 'Добавить в избранное';
const SEND_BY_EMAIL = 'Отправить по почте';
const SAVE_INTO_CLOUD = 'Сохранить в Облако';
const DELETE_FILE = 'Удалить файл';
const PRINT_FILE = 'Распечатать';

const FULL_TOOLBAR_BR = 840;
const UNWRAP_TOOLBAR_BR = 538;

export class ViewerHeader extends Component<Props, State> {
    static defaultProps = {
        enableFavorites: false,
        isPublic: false,
        isStock: false,
        isAttaches: false,
        isAuthorized: false,
        isArchiveItem: false,
        embedded: false,
        showLogo: false,
        item: null,
        isAttachesEnabled: true,
        id: '',
        onClose: noop,
        toggleFavorite: noop,
        onDownload: noop,
        onToggleFavorites: noop,
        onPublish: noop,
        onDelete: noop,
        onPdfEdit: noop,
        onActive: noop,
        onFullscreen: noop,
        onFileClick: noop,
        onOpenInMyCloud: noop,
        renderTopChildren: noop,
        onShowFaceFilter: noop,
        isFullScreen: false,
        facesCount: 0,
        showFacesFilter: false,
        disableClose: false,
        showPdfEditButton: false,
        contentForPrint: null,
        setSearchText: noop,
        enableSearch: false,
        isViewerFileVerifiedByKaspersky: false,
    };

    state = {
        isMoreOpen: false,
        isDownloadOpen: false,
        isButtonTextHidden: false,
        wrapToolbarButtonsOnSmallScreen: false,
        onPrintClick: false,
        expandSearch: false,
    };

    private buttonTextRef = createRef<HTMLDivElement>();
    private moreRef = createRef<HTMLDivElement>();
    private downloadRef = createRef<HTMLDivElement>();
    private faceCounterRef = createRef<HTMLDivElement>();
    private cloneRef = createRef<HTMLDivElement>();
    private unsubscribeMediaWatchers: (() => void)[] = [];

    componentDidMount(): void {
        this.unsubscribeMediaWatchers.push(watchMedia(FULL_TOOLBAR_BR, (hit) => this.handleMediaBreakpointHit(hit, FULL_TOOLBAR_BR)));
        this.unsubscribeMediaWatchers.push(watchMedia(UNWRAP_TOOLBAR_BR, (hit) => this.handleMediaBreakpointHit(hit, UNWRAP_TOOLBAR_BR)));
    }

    componentDidUpdate() {
        const { onPrintClick } = this.state;
        const { contentForPrint } = this.props;

        if (onPrintClick && contentForPrint) {
            this.setState({ onPrintClick: false });
            print(contentForPrint);
        }
    }

    componentWillUnmount(): void {
        this.unsubscribeMediaWatchers.forEach((unsubscribe) => unsubscribe());
    }

    private handleMediaBreakpointHit(hit: boolean, breakpoint: number) {
        switch (breakpoint) {
            case 840:
                this.setState({ isButtonTextHidden: !hit && ENABLE_FULL_RESPONSIVE });
                break;
            case 538:
                this.setState({ wrapToolbarButtonsOnSmallScreen: !hit && ENABLE_FULL_RESPONSIVE });
                break;
        }
    }

    private compensateHorizontalOverflow(posX: number, dropdownWidth: number | undefined) {
        const bodyWidth = document.body.offsetWidth;
        if (dropdownWidth && posX + dropdownWidth > bodyWidth) {
            posX -= posX + dropdownWidth - bodyWidth;
        }
        return Math.max(0, posX);
    }

    private onSearchClick = () => {
        xray.send('viewer_head_search_click');
        this.setState({ expandSearch: true });
    };

    private onSearchClose = () => {
        xray.send('viewer_head_search_close');
        this.setState({ expandSearch: false });
    };

    private calcDropdownPosition =
        (ref, xDisplacement = 0) =>
        (dropdownWidth?: number) => {
            let posX = 0;
            let posY = 0;
            let maxHeight;

            if (ref.current) {
                const elRect = ref.current.getBoundingClientRect();

                posY = elRect.top + elRect.height + window.scrollY + 4;
                posX = elRect.left + xDisplacement;
                posX = this.compensateHorizontalOverflow(posX, dropdownWidth);
                maxHeight = `${window.innerHeight - (posY - window.scrollY) - 8}px`;
            }

            return { posY, posX, maxHeight };
        };

    private handlePublish = (e?): void => {
        const { item, onPublish } = this.props;

        onPublish({ item, textRef: this.buttonTextRef, event: e });
    };

    private handleEditPdf = () => {
        const { item, onPdfEdit } = this.props;

        onPdfEdit(item);
    };

    private handleDownload = (): void => {
        const { item, onDownload } = this.props;

        onDownload(item);
    };

    private handleOnToggleFavorites = (): void => {
        const { item, onToggleFavorites } = this.props;

        onToggleFavorites(item);
    };

    private handleDelete = () => {
        const { item, onDelete } = this.props;

        onDelete(item);
    };

    private handlePrint = () => {
        const { contentForPrint } = this.props;

        xray.send('viewer_head_print_click');

        if (!contentForPrint) {
            snackbarController.showSnackbar({
                type: SnackbarTypes.loading,
                text: 'Подготовка к печати...',
                id: 'printPreparation',
                closable: true,
            });
            this.setState({ onPrintClick: true });
            return;
        }

        print(contentForPrint);
    };

    private handleClose = () => {
        const { onClose, item } = this.props;

        if (item?.weblinkDownloadable || (ENABLE_FULL_RESPONSIVE && IS_BIZ_USER)) {
            return open('/', '_self');
        }

        onClose();
    };

    private handleCloseMore = () => {
        this.props.onActive({ isActive: false });
        this.setState({ isMoreOpen: false });
    };

    private handleMoreClick = () => {
        this.setState((state) => {
            const newValue = !state.isMoreOpen;
            this.props.onActive({ isActive: newValue });
            return { isMoreOpen: newValue };
        });
    };

    private handleDownloadDropdownClick = () => {
        this.setState((state) => {
            const newValue = !state.isDownloadOpen;
            this.props.onActive({ isActive: newValue });
            return { isDownloadOpen: newValue };
        });
        this.props.onActive({ isActive: true });
    };

    private handleCloseDownload = () => {
        this.setState({ isDownloadOpen: false });
        this.props.onActive({ isActive: false });
    };

    private renderDropdownItem = (item) => {
        return <DropdownItemAction active={false} text={item.text} icon={item.icon} />;
    };

    private isDownloadAvailable = (item): boolean => {
        return IS_ONPREMISE ? item.weblinkDownloadable || item.weblinkAccessRights !== 'r' : true;
    };

    private renderDownload = (item) => {
        const allowDownloadAsJpeg = downloadAsJpeg.isAvailable({ ext: item.ext, itemType: item.type, storage: item.storage });
        const { isDownloadOpen, isButtonTextHidden } = this.state;
        const { isPublic, isAttaches, isArchiveItem, isUnpublished, isSuccessAuthWhenDownload } = this.props;
        // достаточно проверки только на флаг DOWNLOADABLE, т.к. если счетчик кончается, веблинк удаляется
        const showDownloadBtn = this.isDownloadAvailable(item);

        if ((isArchiveItem && (item.isFolder || item.isEncrypted)) || isUnpublished) {
            return null;
        }

        const btnText = item.isFolder ? 'Скачать' : 'Скачать файл';

        return (
            <>
                {isSuccessAuthWhenDownload && IS_PUBLIC && (
                    <FloatingTooltip
                        target={this.downloadRef.current}
                        title="Файл готов к скачиванию"
                        text={`Нажмите «${btnText}»`}
                        placement={ETooltipPlacement.bottom}
                        closeOnOutsideClick={false}
                        qaId="required-auth-when-download"
                        appearance={ETooltipAppearance.dark}
                    />
                )}
                <div ref={this.downloadRef}>
                    {showDownloadBtn && (
                        <ViewerHeaderButton
                            title={btnText}
                            icon={<Icon20DownloadOutline />}
                            iconOnly={isButtonTextHidden}
                            primary={isPublic && !isAttaches && !item.weblinkDownloadable}
                            onClick={this.handleDownload}
                            onClickDropdown={this.handleDownloadDropdownClick}
                            isDropdownOpen={isDownloadOpen}
                            showDropDown={allowDownloadAsJpeg}
                            id="download"
                        />
                    )}
                    {isDownloadOpen && (
                        <DropdownList
                            list={downloadAsJpeg.getDropdownItems({
                                itemOrId: item,
                                gaSuffix: 'viewer',
                                ext: item.ext,
                            })}
                            renderItem={this.renderDropdownItem}
                            close={this.handleCloseDownload}
                            posX={0}
                            posY={0}
                            theme={[DropdownTheme.jpeg, DropdownTheme.dark]}
                            parentRef={this.downloadRef}
                            calcPosition={this.calcDropdownPosition(this.downloadRef, 58)}
                            closeOnResize
                            closeOnScroll
                            title="Скачать в"
                            gaId="viewer-dnld"
                        />
                    )}
                </div>
            </>
        );
    };

    private getMoreItems = (isStory = false) => {
        const { isAttachesEnabled } = this.props;

        const moreItems = isStory
            ? [
                  {
                      id: 'download',
                      text: 'Скачать',
                      onClick: () => this.handleDownload(),
                      icon: <Icon20DownloadOutline />,
                  },
                  {
                      id: 'openinparent',
                      text: 'Показать в папке',
                      onClick: this.props.onOpenParent,
                      icon: <ExternalLinkIcon />,
                  },
                  {
                      id: 'copy',
                      text: 'Копировать',
                      onClick: this.props.onCopy,
                      icon: <Icon20CopyOutline />,
                  },
                  {
                      id: 'move',
                      text: 'Переместить в папку',
                      onClick: this.props.onMove,
                      icon: <Icon20FolderSimpleArrowRightOutlune />,
                  },
                  {
                      id: 'delete',
                      text: 'Удалить',
                      onClick: () => this.handleDelete(),
                      icon: <Icon20DeleteOutline />,
                  },
              ]
            : [
                  {
                      id: 'openinparent',
                      text: 'Показать в папке',
                      onClick: this.props.onOpenParent,
                      icon: <ExternalLinkIcon />,
                  },
                  {
                      id: 'copy',
                      text: 'Копировать',
                      onClick: this.props.onCopy,
                      icon: <Icon20CopyOutline />,
                  },
                  {
                      id: 'move',
                      text: 'Переместить в папку',
                      onClick: this.props.onMove,
                      icon: <Icon20FolderSimpleArrowRightOutlune />,
                  },
              ];

        if (isAttachesEnabled) {
            moreItems.push({
                id: 'mail',
                text: SEND_BY_EMAIL,
                onClick: this.props.onMail,
                icon: <Icon20MailOutline />,
            });
        }

        return moreItems;
    };

    private filloutPrivateToolbarMenu(
        menuItems: ListItem[],
        options: {
            enableFavorites: boolean;
            isCanDownload: boolean;
            isInFavorites: boolean;
            isPublished: boolean;
            isCanPrint: boolean;
        }
    ) {
        const { enableFavorites, isCanDownload, isInFavorites, isPublished, isCanPrint } = options;

        if (isCanDownload) {
            menuItems.push({
                icon: <Icon20Chain />,
                id: 'publish',
                onClick: () => this.handlePublish(),
                text: isPublished ? shareLink : getLinkText,
            });
        }
        if (enableFavorites) {
            menuItems.push({
                icon: isInFavorites ? (
                    <Icon20Like color="var(--vkui--color_icon_contrast_themed)" />
                ) : (
                    <Icon20LikeOutline color="var(--vkui--color_icon_contrast_themed)" />
                ),
                id: 'favorite',
                onClick: () => this.handleOnToggleFavorites(),
                text: isInFavorites ? deleteFromFavorites : addToFavorites,
            });
        }
        if (isCanPrint) {
            menuItems.push({
                icon: <Icon20PrinterOutline />,
                id: 'print',
                onClick: () => this.handlePrint(),
                text: PRINT_FILE,
            });
        }
        menuItems.push({
            icon: <Icon20DeleteOutline />,
            id: 'delete',
            onClick: () => this.handleDelete(),
            text: DELETE_FILE,
        });
    }

    private renderPrivateToolbarItems = () => {
        const { item, isArchiveItem, enableFavorites, showPdfEditButton, allowPrinting, isSuccessAuthWhenDownloadVariant1 } = this.props;
        const { isMoreOpen, isButtonTextHidden, wrapToolbarButtonsOnSmallScreen } = this.state;

        const isInFavorites = Boolean(item && 'isInFavorites' in item && item.isInFavorites);
        const isPublished = Boolean(item && 'weblink' in item && item.weblink);

        const downloadBttn = this.renderDownload(item);
        const isCanDownload = this.isDownloadAvailable(item);
        const isCanPrint = allowPrinting || false;

        if (isArchiveItem) {
            return downloadBttn;
        }

        const menuItems: ListItem[] = [];

        if (wrapToolbarButtonsOnSmallScreen) {
            this.filloutPrivateToolbarMenu(menuItems, { enableFavorites, isCanDownload, isInFavorites, isPublished, isCanPrint });
        }

        menuItems.push(...this.getMoreItems());

        const btnText = item?.isFolder ? 'Скачать' : 'Скачать файл';

        return (
            <>
                {isSuccessAuthWhenDownloadVariant1 && IS_PUBLIC && !reDownloadController.isDownloadHappened() && (
                    /* tempexp_15344-next-line */
                    <FloatingTooltip
                        target={this.downloadRef.current}
                        title="Файл готов к скачиванию"
                        text={`Нажмите «${btnText}»`}
                        placement={ETooltipPlacement.bottom}
                        closeOnOutsideClick={false}
                        qaId="required-auth-when-download"
                        appearance={ETooltipAppearance.dark}
                        onShow={() => requiredAuthorizationHelpers.sendGa('shw-redwnld-tltip', 'variant1', 'single')}
                        onClick={() => requiredAuthorizationHelpers.sendGa('clck-redwnld-tltip', 'variant1', 'single')}
                        onClose={() => requiredAuthorizationHelpers.sendGa('cls-redwnld-tltip', 'variant1', 'single')}
                    />
                )}
                {(!wrapToolbarButtonsOnSmallScreen || !isCanDownload) && (
                    <ViewerHeaderButton
                        title={isPublished ? shareLink : getLinkText}
                        icon={<Icon20Chain />}
                        iconOnly={isButtonTextHidden}
                        onClick={this.handlePublish}
                        textRef={this.buttonTextRef}
                        id="publish"
                        primary
                    />
                )}
                {showPdfEditButton && (
                    <ViewerHeaderButton
                        forceText={true}
                        title={'Редактировать'}
                        icon={<Icon20WriteOutline />}
                        iconOnly={isButtonTextHidden}
                        onClick={this.handleEditPdf}
                        id="edit"
                    />
                )}
                {downloadBttn}
                {!wrapToolbarButtonsOnSmallScreen && enableFavorites && (
                    <ViewerHeaderButton
                        title={<div className={styles.button_fav}>{isInFavorites ? deleteFromFavorites : addToFavorites}</div>}
                        hint={isInFavorites ? deleteFromFavorites : addToFavorites}
                        icon={
                            isInFavorites ? (
                                <Icon20Like color="var(--vkui--color_icon_contrast_themed)" />
                            ) : (
                                <Icon20LikeOutline color="var(--vkui--color_icon_contrast_themed)" />
                            )
                        }
                        iconOnly={isButtonTextHidden}
                        onClick={this.handleOnToggleFavorites}
                        id="favorite"
                    />
                )}
                <div className={styles.iconsGroup}>
                    {!wrapToolbarButtonsOnSmallScreen && isCanPrint && (
                        <ViewerHeaderButton
                            title=""
                            icon={<Icon20PrinterOutline />}
                            onClick={this.handlePrint}
                            hint={PRINT_FILE}
                            isFilled={false}
                            id="print"
                        />
                    )}
                    {!wrapToolbarButtonsOnSmallScreen && (
                        <ViewerHeaderButton
                            title=""
                            icon={<Icon20DeleteOutline />}
                            onClick={this.handleDelete}
                            hint={DELETE_FILE}
                            isFilled={false}
                            id="delete"
                        />
                    )}
                    <div ref={this.moreRef}>
                        <ViewerHeaderButton
                            title=""
                            icon={<Icon20More />}
                            onClick={this.handleMoreClick}
                            hint="Дополнительные действия"
                            id="more"
                        />
                        {isMoreOpen && (
                            <DropdownList
                                list={menuItems}
                                renderItem={this.renderDropdownItem}
                                close={this.handleCloseMore}
                                theme={DropdownTheme.dark}
                                parentRef={this.moreRef}
                                calcPosition={this.calcDropdownPosition(this.moreRef, 2)}
                                closeOnResize
                                gaId="viewer-more"
                            />
                        )}
                    </div>
                </div>
            </>
        );
    };

    private renderStoryToolbarItems = () => {
        const { item, enableFavorites } = this.props;
        const { isMoreOpen, isButtonTextHidden } = this.state;

        const isInFavorites = Boolean(item && 'isInFavorites' in item && item.isInFavorites);
        const isPublished = Boolean(item && 'weblink' in item && item.weblink);

        return (
            <>
                <ViewerHeaderButton
                    title={isPublished ? shareLink : getLinkText}
                    hint={isPublished ? shareLink : getLinkText}
                    icon={<Icon20Chain />}
                    iconOnly={isButtonTextHidden}
                    onClick={this.handlePublish}
                    textRef={this.buttonTextRef}
                    id="publish"
                    primary
                />
                {enableFavorites && (
                    <ViewerHeaderButton
                        title={<div className={styles.button_fav}>{isInFavorites ? deleteFromFavorites : addToFavorites}</div>}
                        hint={isInFavorites ? deleteFromFavorites : addToFavorites}
                        icon={
                            isInFavorites ? (
                                <Icon20Like color="var(--vkui--color_icon_contrast_themed)" />
                            ) : (
                                <Icon20LikeOutline color="var(--vkui--color_icon_contrast_themed)" />
                            )
                        }
                        iconOnly={isButtonTextHidden}
                        onClick={this.handleOnToggleFavorites}
                        id="favorite"
                    />
                )}
                <div className={styles.iconsGroup}>
                    <div ref={this.moreRef}>
                        <ViewerHeaderButton
                            title=""
                            icon={<Icon20More />}
                            onClick={this.handleMoreClick}
                            hint="Дополнительные действия"
                            id="more"
                        />
                        {isMoreOpen && (
                            <DropdownList
                                list={this.getMoreItems(true)}
                                renderItem={this.renderDropdownItem}
                                close={this.handleCloseMore}
                                posX={0}
                                posY={0}
                                theme={DropdownTheme.dark}
                                parentRef={this.moreRef}
                                calcPosition={this.calcDropdownPosition(this.moreRef, 2)}
                                closeOnResize
                                gaId="viewer-more"
                            />
                        )}
                    </div>
                </div>
            </>
        );
    };

    private renderStockToolbarItems = () => {
        const { item, isAuthorized, isArchiveItem, onClone, itemStorage } = this.props;
        const { isButtonTextHidden } = this.state;
        const showCloneExcludeArchive = Boolean(canCloneWeblink(isAuthorized, itemStorage, true)) && !isArchiveItem;

        return (
            <>
                <>
                    {!isArchiveItem && (
                        <ViewerHeaderButton
                            title={shareLink}
                            hint={shareLink}
                            icon={<Icon20Chain />}
                            iconOnly={isButtonTextHidden}
                            onClick={this.handlePublish}
                            textRef={this.buttonTextRef}
                            id="publish"
                            primary
                        />
                    )}
                    {showCloneExcludeArchive && (
                        <ViewerHeaderButton
                            title={SAVE_INTO_CLOUD}
                            hint={SAVE_INTO_CLOUD}
                            icon={<Icon20CloudArrowUpOutline />}
                            iconOnly={isButtonTextHidden}
                            onClick={onClone}
                            id="clone"
                            collapsableText
                        />
                    )}
                </>
                {this.renderDownload(item)}
            </>
        );
    };

    private renderPublicToolbarItems = (showSendViaMail: boolean, showLink: boolean) => {
        const {
            item,
            isAuthorized,
            isArchiveItem,
            embedded,
            isFullScreen,
            onFullscreen,
            isAttachesEnabled,
            isUnpublished,
            facesCount = 0,
            onShowFaceFilter,
            itemStorage,
            isStock,
            disableClose,
        } = this.props;
        let isTempAttachType = false;
        if (item && 'attachType' in item) {
            isTempAttachType = item.attachType === EAttachTypes.temporary;
        }
        const showClone = !item?.weblinkDownloadable && Boolean(canCloneWeblink(isAuthorized, itemStorage, true)) && !isTempAttachType;
        const showOpenInCloud = !showClone && !item?.weblinkDownloadable && embedded && getIsCloudAvailabe();
        const showCopyLink = canCloneWeblink(isAuthorized, itemStorage);

        const showCloneExcludeArchive = showClone && !isArchiveItem;
        const { isButtonTextHidden } = this.state;

        return (
            <>
                {this.renderDownload(item)}
                {showCloneExcludeArchive && (
                    <>
                        <ViewerHeaderButton
                            title={SAVE_INTO_CLOUD}
                            hint={SAVE_INTO_CLOUD}
                            icon={<Icon20CloudArrowUpOutline />}
                            iconOnly={isButtonTextHidden}
                            onClick={this.props.onClone}
                            id="clone"
                            collapsableText
                            textRef={this.cloneRef}
                        />
                        {/* Временно выключил на сток-файлах. Включить после перевода стоков на новый SSR - CLOUDWEB-14426 */}
                        {!isStock && <RegisterCloudTooltip targetRef={this.cloneRef} closeOnScroll={true} />}
                    </>
                )}
                {showOpenInCloud && (
                    <ViewerHeaderButton
                        title={'Открыть в моём Облаке'}
                        hint={'Открыть в моём Облаке'}
                        icon={<ExternalLinkIcon />}
                        iconOnly={isButtonTextHidden}
                        onClick={this.props.onOpenInMyCloud}
                        id="openinmy"
                        collapsableText
                    />
                )}
                {isAttachesEnabled && showSendViaMail && !isArchiveItem && (
                    <ViewerHeaderButton
                        title={SEND_BY_EMAIL}
                        hint={SEND_BY_EMAIL}
                        icon={<Icon20MailOutline data-qa-id="mail" />}
                        iconOnly={isButtonTextHidden}
                        onClick={this.props.onMail}
                        id="mail"
                        collapsableText
                    />
                )}
                {showLink && !item?.weblinkDownloadable && !isArchiveItem && !isUnpublished && (
                    <ViewerHeaderButton
                        title={showCopyLink ? getLinkText : unpublishLinkText}
                        hint={showCopyLink ? getLinkText : unpublishLinkText}
                        icon={<Icon20Chain />}
                        iconOnly={isButtonTextHidden}
                        onClick={this.handlePublish}
                        textRef={this.buttonTextRef}
                        id="publish"
                        collapsableText
                    />
                )}
                {facesCount > 0 && (
                    <>
                        <ViewerHeaderButton
                            title=""
                            hint="Показать фильтр по лицам"
                            textOnIcon={facesCount?.toString()}
                            icon={<ShapeIcon />}
                            onClick={onShowFaceFilter}
                            textRef={this.faceCounterRef}
                            id="showFaces"
                            iconOnly
                        />
                        {Boolean(this.faceCounterRef?.current) && (
                            <FaceInfoTooltip onApply={onShowFaceFilter} targetRef={this.faceCounterRef} />
                        )}
                    </>
                )}
                {embedded && (
                    <ViewerHeaderButton
                        title=""
                        icon={
                            isFullScreen ? (
                                <Icon20FullscreenExitOutline width={16} height={16} />
                            ) : (
                                <Icon20FullscreenOutline width={16} height={16} />
                            )
                        }
                        onClick={onFullscreen}
                        hint={isFullScreen ? 'Выйти из полноэкранного режима' : 'Полноэкранный режим'}
                        id="fullscreen"
                    />
                )}
                {!disableClose && (
                    <Hint text="Закрыть" theme="dark" showDelay>
                        <div className={styles.closeIcon} onClick={this.handleClose}>
                            <Icon20Cancel />
                        </div>
                    </Hint>
                )}
            </>
        );
    };

    private renderAttachToolbarItems = () => {
        const { item, isAuthorized, isArchiveItem, itemStorage, allowPrinting } = this.props;
        const { isButtonTextHidden } = this.state;
        const showClone = Boolean(canCloneWeblink(isAuthorized, itemStorage));
        const attachType = (item as AttachesItem)?.attachType;
        const isTemporary = attachType === EAttachTypes.temporary;
        const isCloudAttach = attachType === EAttachTypes.cloud;

        // eslint-disable-next-line max-lines
        return (
            <>
                {showClone && !isArchiveItem && !isTemporary && !isCloudAttach && (
                    <>
                        <ViewerHeaderButton
                            title={shareLink}
                            hint={shareLink}
                            icon={<Icon20Chain />}
                            iconOnly={isButtonTextHidden}
                            onClick={this.handlePublish}
                            textRef={this.buttonTextRef}
                            id="publish"
                            primary
                        />
                        <ViewerHeaderButton
                            title={SAVE_INTO_CLOUD}
                            hint={SAVE_INTO_CLOUD}
                            icon={<Icon20CloudArrowUpOutline />}
                            iconOnly={isButtonTextHidden}
                            onClick={this.props.onClone}
                            id="clone"
                            collapsableText
                        />
                    </>
                )}
                {this.renderDownload(item)}
                {allowPrinting && (
                    <ViewerHeaderButton
                        title=""
                        icon={<Icon20PrinterOutline />}
                        onClick={this.handlePrint}
                        hint={PRINT_FILE}
                        isFilled={false}
                        id="print"
                    />
                )}
            </>
        );
    };

    private renderAlbumsToolbarItems = () => {
        const { item } = this.props;
        const isInFavorites = Boolean(item && 'isInFavorites' in item && item.isInFavorites);

        const downloadBttn = this.renderDownload(item);

        return (
            <>
                {downloadBttn}
                <ViewerHeaderButton
                    title={<div className={styles.button_fav}>{isInFavorites ? deleteFromFavorites : addToFavorites}</div>}
                    icon={
                        isInFavorites ? (
                            <Icon20Like color="var(--vkui--color_icon_contrast_themed)" />
                        ) : (
                            <Icon20LikeOutline color="var(--vkui--color_icon_contrast_themed)" />
                        )
                    }
                    hint={isInFavorites ? deleteFromFavorites : addToFavorites}
                    onClick={this.handleOnToggleFavorites}
                    id="favorite"
                    iconOnly
                />
                <div className={styles.iconsGroup}>
                    <ViewerHeaderButton
                        title="Удалить"
                        icon={<Icon20DeleteOutline />}
                        onClick={this.handleDelete}
                        hint={DELETE_FILE}
                        isFilled={false}
                        id="delete"
                        iconOnly
                    />
                </div>
            </>
        );
    };

    private renderToolbar = () => {
        const { isPublic, isStock, isAttaches, embedded, item } = this.props;

        if (item?.storage === EStorageType.albums) {
            return this.renderAlbumsToolbarItems();
        }

        if (isAttaches) {
            return this.renderAttachToolbarItems();
        }

        if (isStock) {
            return this.renderStockToolbarItems();
        }

        if (isPublic) {
            return this.renderPublicToolbarItems(!embedded, !!embedded);
        }

        if (item?.storage === EStorageType.story) {
            return this.renderStoryToolbarItems();
        }

        return this.renderPrivateToolbarItems();
    };

    render(): ReactElement | null {
        const {
            item,
            isFullScreen,
            onFullscreen,
            onFileClick,
            embedded,
            showLogo,
            renderTopChildren,
            topTitle,
            topSubTitle,
            showFacesFilter,
            disableClose,
            isAttaches,
            showPdfEditButton,
            setSearchText,
            enableSearch,
            isViewerFileVerifiedByKaspersky,
        } = this.props;
        const { isDownloadOpen, isMoreOpen, expandSearch } = this.state;

        if (!item) {
            return null;
        }

        let topTitleBlock;
        if (item.storage === EStorageType.story) {
            topTitleBlock = (
                <div className={classNames(styles.fileInfo, styles.fileInfo_story)}>
                    <div className={styles.fileName}>
                        <NameComponent name={topTitle ?? ''} extension="" truncate showTooltip fullWidth />
                    </div>
                    <div className={styles.fileSize}>{topSubTitle}</div>
                </div>
            );
        } else {
            const name = item.isFolder ? item.name : item?.nameWithoutExt || '';

            topTitleBlock = (
                <div className={styles.fileInfo}>
                    <div className={styles.fileName}>
                        <NameComponent
                            name={name}
                            extension={item?.ext}
                            truncate
                            delayTruncate={embedded}
                            showTooltip
                            showUnknownExtension
                        />
                        {[EStorageType.public, EStorageType.stock].includes(item.storage) &&
                            !IS_PUBLIC_FOLDER &&
                            isViewerFileVerifiedByKaspersky && <ProtectedHint text="Файл проверен антивирусом Касперского" />}
                    </div>
                    {typeof item.size === 'number' ? <div className={styles.fileSize}>{getSize(item.size)}</div> : null}
                </div>
            );
        }

        return (
            <div
                className={classNames({
                    [styles.root]: true,
                    [styles.root_attaches]: item?.storage === EStorageType.attaches || item?.storage === EStorageType.viewerAttaches,
                    [styles.root_embedded]: embedded,
                    [styles.root_story]: item?.storage === EStorageType.story,
                    [buttonStyles.hide_text]: showPdfEditButton,
                })}
            >
                {renderTopChildren && renderTopChildren(isDownloadOpen || isMoreOpen)}
                {!expandSearch && (
                    <div className={styles.controlsWrapper}>
                        <div
                            className={classNames(styles.group, styles.leftGroup, {
                                [styles.leftGroup_small]: Boolean(showFacesFilter),
                            })}
                        >
                            {item?.storage === EStorageType.attaches || item?.storage === EStorageType.viewerAttaches ? (
                                <AttachInfo
                                    name={item?.subject}
                                    author={item?.authorName}
                                    timestamp={item?.mtime}
                                    fileName={item?.nameWithoutExt}
                                    fileExt={item?.ext}
                                    size={getSize(item?.size || 0)}
                                    isTemporary={item?.attachType === EAttachTypes.temporary}
                                    onClick={onFileClick}
                                />
                            ) : (
                                <>
                                    {showLogo && (
                                        <div
                                            className={classNames(styles.logo, {
                                                [styles.logoResponsive]: ENABLE_FULL_RESPONSIVE,
                                            })}
                                        >
                                            <Logo white />
                                        </div>
                                    )}
                                    {topTitleBlock}
                                </>
                            )}
                        </div>
                        <div className={classNames(styles.group, styles.middleGroup)}>{this.renderToolbar()}</div>
                        {!embedded && (
                            <div className={classNames(styles.group, styles.rightGroup)}>
                                {enableSearch && (
                                    <ViewerHeaderButton
                                        title=""
                                        icon={<Icon20Search />}
                                        onClick={this.onSearchClick}
                                        hint={'Поиск по документу'}
                                        id='document-search"'
                                    />
                                )}
                                {isAttaches && (
                                    <div className={styles.marketingPromoButton}>
                                        <MarketingPromoButton />
                                    </div>
                                )}
                                <ViewerHeaderButton
                                    title=""
                                    icon={
                                        isFullScreen ? (
                                            <Icon20FullscreenExitOutline width={16} height={16} />
                                        ) : (
                                            <Icon20FullscreenOutline width={16} height={16} />
                                        )
                                    }
                                    onClick={onFullscreen}
                                    hint={isFullScreen ? 'Выйти из полноэкранного режима' : 'Полноэкранный режим'}
                                    id="fullscreen"
                                />
                                {!disableClose && (
                                    <Hint text="Закрыть" theme="dark" showDelay>
                                        <div className={styles.closeIcon} onMouseDown={this.handleClose}>
                                            <Icon20Cancel />
                                        </div>
                                    </Hint>
                                )}
                            </div>
                        )}
                    </div>
                )}

                {expandSearch && <DocumentSearch onSearchClose={this.onSearchClose} setSearchText={setSearchText} />}
            </div>
        );
    }
}
